import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';

class MessageInvitePeopleCta extends PureComponent {
    handleClick = () => {
        this.props.history.push({
            pathname: `/settings/team/current/people`,
            state: {
                closeUrl: this.props.location.pathname
            }
        });
    }

    render() {
        return (
            <button className="btn btn-link btn-colored" onClick={this.handleClick}><strong className="medium">invite your teammates</strong></button>
        )
    }
}

export default withRouter(MessageInvitePeopleCta);
